export default __webpack_public_path__ + "static/bio-brigade-c847938404b4f281590c8c8196517cd0.jpeg";